// App.tsx
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthProvider } from './context/AuthContext';
import { LibellesMenuProvider } from './context/LibellesMenuContext';
import { AppProvider } from './context/AppContext';
import AppRoutes from './AppRoutes';
import './services/api.interceptor'; // Import de l'intercepteur Axios
import './i18n';                     // Initialisation i18next (FR/EN)
import { BASENAME } from './config/env';

const App: React.FC = () => {
  // Hook au niveau racine pour forcer le re-render de tout l'arbre au changement de langue
  const { i18n } = useTranslation();

  return (
    <BrowserRouter basename={BASENAME}>
      <AuthProvider>
        <LibellesMenuProvider>
          <AppProvider>
            <AppRoutes key={i18n.language} />
          </AppProvider>
        </LibellesMenuProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;